import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BillingCycle from "./billing-cycle";
import { fetchScheduledOrders } from "actions/account/subscription";
import Loader from "components/loader";
import DispatchedOrder from "components/account/subscription/scheduled-orders/dispatched-order";

const ScheduledOrders = () => {
	const { scheduledOrders } = useSelector((state) => state.account.subscription);

	const orders = Object.values(scheduledOrders);
	const dispatch = useDispatch();

	useEffect(() => {
		if (!orders.length)
			dispatch(fetchScheduledOrders());
	}, []);

	if (!orders.length) return <Loader ring className="w-7 h-7 my-3" />;

	return (
		<>
			<DispatchedOrder />
			{orders.map(cycle => cycle.status !== "SKIPPED" && <BillingCycle key={cycle.id} cycle={cycle} />)}
		</>
	);
};

export default ScheduledOrders;
